export default __webpack_public_path__ + "static/media/thumbs_up_green.32ba54f7.png";